export const handleDate = (dateString) => {
  if (dateString) {
    const date = new Date(dateString)

    // Date formatting
    const day = date.getDate().toString().padStart(2, '0')
    const month = date.toLocaleString('default', { month: 'short' })
    const year = date.getFullYear()

    // Time formatting
    const hours = date.getHours()
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')

    // Convert to 12-hour format
    const ampm = hours >= 12 ? 'PM' : 'AM'
    const displayHours = hours % 12 || 12

    return `${day}-${month}-${year} ${displayHours}:${minutes}:${seconds} ${ampm}`
  }
  return ''
}

export const getCleanPdfName = (pdfName) => {
  // Extract filename from URL first
  const filename = pdfName.split('/').pop()
  return filename.replace(/^[a-f0-9-]+-/, '')
}
